import { Collection, CollectionDelete, CollectionEdit } from '../../apis/media/Collection';
import { MediaDelete } from '../../apis/media/Media';
import { UploadMedia, UploadMediaColletionName } from '../../apis/media/Upload';

export const MediaService = {
  upload: async (placeId: number, media: any, type: string, token: string | null) => {
    if (!token) return;

    return await UploadMedia(placeId, media, type, token);
  },
  uploadWithColletion: async (
    placeId: number,
    collectionId: number,
    media: any,
    type: string,
    token: string | null,
  ) => {
    if (!token) return;

    return await UploadMediaColletionName(placeId, collectionId, media, type, token);
  },
  createCollection: async (placeId: number, name: string) => {
    return await Collection(placeId, name);
  },
  delete: async (mediaId: number) => {
    return await MediaDelete(mediaId);
  },
  deleteCollection: async (collectionId: number) => {
    return await CollectionDelete(collectionId);
  },
  editCollection: async (collectionId: number, name: string) => {
    return await CollectionEdit(collectionId, name);
  },
};
